/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import AdvSentimentService from '../../service/advSentiment.js';

const state = {
  
};

const getters = {
  
};

const mutations = {
  
};

const actions = {
  async fetchSentimentTrendGraph({ getters }, { conversationId }) {
    return AdvSentimentService.fetchSentimentTrendGraph(getters.authUser, conversationId);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
